import React, {useCallback, useState} from 'react';
import {makeStyles} from "@material-ui/styles";

import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import red from "@material-ui/core/colors/red";

const StyledTextField = ({ label, className, fullWidth, multiline, rows, type, placeholder, value, onChange, error, formatOnBlur }) => {
    const classes = useStyles();

    const [displayValue, setDisplayValue] = useState(value);

    const handleChange = useCallback(event => {
        const newVal = event.target.value;
        setDisplayValue(newVal);
    }, []);

    const handleBlur = useCallback(event => {
        let newVal = event.target.value;
        if (formatOnBlur){
            const formatted = formatOnBlur(newVal);

            if (formatted !== newVal){
                setDisplayValue(formatted);
            }
            onChange(formatted);
        } else {
            onChange(newVal);
        }
    }, [onChange, formatOnBlur]);

    return(
        <div className={classes.wrapper}>
            { label ? <Typography className={classes.label}>{label}</Typography> : null }
            <InputBase
                value={displayValue || ''}
                min={0}
                step={0.01}
                placeholder={placeholder || ''}
                type={type || 'text'}
                rows={rows || undefined}
                multiline={multiline || false}
                className={classes.input + (className ? ' ' + className : '')}
                onBlur={handleBlur}
                onChange={handleChange}
                fullWidth={fullWidth || false}
            />
            { error ? <Typography className={classes.error}>{ error }</Typography> : null }
        </div>
    )
}

const useStyles = makeStyles({
    wrapper: {
        padding: '0.5rem'
    },
    input: {
        border: '0.25rem solid rgba(0,0,0,0.6)',
        backgroundColor: 'rgba(0,0,0,0.1)',
        color: 'rgba(0,0,0,0.6)',
        padding: '0',
        '& .MuiInputBase-input': {
            padding: '0.3rem',
            fontSize: '1.1rem',
            fontWeight: 'bolder',
            maxWidth: '100%'
        }
    },
    label: {
        fontWeight: 'bold',
        fontSize: '1rem',
        color: 'rgba(0,0,0,0.6)',
        margin: 0
    },
    error: {
        color: red['500'],
        fontSize: "0.9rem"
    }
});

export default StyledTextField;